/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { UploadTargetHeader } from './UploadTargetHeader';
import {
    UploadTargetHeaderFromJSON,
    UploadTargetHeaderFromJSONTyped,
    UploadTargetHeaderToJSON,
    UploadTargetHeaderToJSONTyped,
} from './UploadTargetHeader';

/**
 * 
 * @export
 * @interface UploadTarget
 */
export interface UploadTarget {
    /**
     * 
     */
    position: number;
    /**
     * 
     */
    method: UploadTargetMethodEnum;
    /**
     * 
     */
    url: string;
    /**
     * 
     */
    headers: Array<UploadTargetHeader>;
    /**
     * 
     */
    expires_at: Date;
}


/**
 * @export
 */
export const UploadTargetMethodEnum = {
    Put: 'PUT',
} as const;
export type UploadTargetMethodEnum = typeof UploadTargetMethodEnum[keyof typeof UploadTargetMethodEnum];


/**
 * Check if a given object implements the UploadTarget interface.
 */
export function instanceOfUploadTarget(value: object): value is UploadTarget {
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('method' in value) || value['method'] === undefined) return false;
    if (value['method'] !== 'PUT') return false;
    
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('headers' in value) || value['headers'] === undefined) return false;
    if (!('expires_at' in value) || value['expires_at'] === undefined) return false;
    return true;
}

export function UploadTargetFromJSON(json: any): UploadTarget {
    return UploadTargetFromJSONTyped(json, false);
}

export function UploadTargetFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadTarget {
    if (json == null) {
        return json;
    }
    return {
        
        'position': json['position'],
        'method': json['method'],
        'url': json['url'],
        'headers': ((json['headers'] as Array<any>).map(UploadTargetHeaderFromJSON)),
        'expires_at': (json['expires_at'] == null ? json['expires_at'] : parseDateTime(json['expires_at'])),
    };
}

export function UploadTargetToJSON(json: any): UploadTarget {
    return UploadTargetToJSONTyped(json, false);
}

export function UploadTargetToJSONTyped(value?: UploadTarget | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': value['position'],
        'method': value['method'],
        'url': value['url'],
        'headers': ((value['headers'] as Array<any>).map(UploadTargetHeaderToJSON)),
        'expires_at': value['expires_at'] == null ? value['expires_at'] : serializeDateTime(value['expires_at']),
    };
}

